		$.ajaxSetup({
	    	headers: {
	        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	    	}
		});

		$(document).ready(function () {

			$(this).on('click', '#yesChangeStatus', function(){

				$.ajax({

					url: "/newstatus/"+$(this).data('id'),
					type: 'POST', 
					data: {'date' : $('#datepicker_input').val(), 'statustype' : $("#statustype_select").val()}, 
					success : function (result){
						if (result.success === true){
							$('#ChangeStatusModal').modal('hide');
							$('#historystatus').prepend('<tr><td>'+result.name+'</td><td>'+result.date+'</td></tr>');

						}
					}
				});
			});


		});

